<template>
  <div>
    <program-head :isNeedBack="false" />
    <div v-if="Programs.length">
      <table class="table-wrapperNew">
        <tr v-for="program in Programs">
          <td class="main-tab" :class="getBg(program)">
            <table>
              <tr>
                <td class="id-num" @click="editTrade(program)">{{ program.id }}</td>
                <td class="btcusd">{{ program.asset }}</td>
                <td class="text-1">Active</td>
                <td class="text-1">Deposited/Committed</td>
                <td class="text-1">Last deposit</td>
              </tr>
              <tr>
                <td></td>
                <td class="text-2">{{ program.type_name }}</td>
                <td class="text-2">{{ getDate(program.start_date) }} – {{ getDate(program.end_date) }}</td>
                <td class="text-2">${{ program.total_deposited }} / ${{ program.committed }}</td>
                <td class="text-2">${{ program.lda }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="text-3">{{getDays(program)}}d left</td>
                <td class="text-3">${{ parseFloat(program.committed) - parseFloat(program.total_deposited) }} left</td>
                <td class="text-3">{{ getDate(program.ldd) === 'Invalid date' ? '' : getDate(program.ldd) }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <!--    <custom-pagination />-->
    </div>
  </div>
</template>

<script>
import CustomPagination from "../partials/CustomPagination";
import ProgramHead from "./ProgramHead";
import moment from "moment";

export default {
  name: "ProgramsTrade",
  components: {ProgramHead, CustomPagination},
  data() {
    return {
      fullTimeFormat: 'YYYY-MM-DD HH:MM:SS',
      hoursFormat: 'HH:MM',
      daysFormat: 'DD HH:MM',
      monthFormat: 'DD-MM',
      yearFormat: 'YYYY-MM',
    }
  },
  computed: {
    isEditTrade: {
      get() {
        return this.$store.state.isEditTrade;
      },
      set(value) {
        this.$store.commit('setter', {isEditTrade: value})
      }
    },
    currentProgram: {
      get() {
        return this.$store.state.currentProgram;
      },
      set(value) {
        this.$store.commit('setter', {currentProgram: value})
      }
    },
    Programs() {
      return this.$store.state.programs;
    }
  },
  methods: {
    getDate(date) {
      let data = moment(date);
      let currentDate = moment();
      let isToday = data.date() === currentDate.date();
      let isCurrentMonth = data.format('MM') === currentDate.format('MM');
      let isCurrentYear = data.format('YYYY') === currentDate.format('YYYY');

      if (isToday) {
        return data.format(this.hoursFormat)
      }

      if (!isToday && isCurrentMonth) {
        return data.format(this.daysFormat)
      }

      if (isCurrentYear && !isCurrentMonth) {
        return data.format(this.monthFormat)
      }

      return data.format(this.yearFormat);
    },
    getDays(program) {
     let days = Math.abs(
          moment(program.start_date, 'YYYY-MM-DD')
              .startOf('day')
              .diff(moment(program.end_date, 'YYYY-MM-DD').startOf('day'), 'days')
      );

     return days < 365 ? days : parseInt(days/365);
    },
    editTrade(program) {
      this.currentProgram = program
      this.isEditTrade = true;
    },
    getBg(program) {
      let bgClass = 'b-white';
      let weeks = Math.abs(
          moment(program.start_date, 'YYYY-MM-DD')
              .startOf('week')
              .diff(moment(program.end_date, 'YYYY-MM-DD').startOf('week'), 'weeks')
      );
      let days = this.getDays(program);

      if (weeks > 2) {
        bgClass = 'b-brightGreen'
      }
      if (weeks <= 2) {
        bgClass = 'b-green'
      }

      if (weeks < 1 && days > 2) {
        bgClass = 'b-brightYellow'
      }

      if (days <= 2) {
        bgClass = 'b-yellow'
      }

      return bgClass;
    }
  }
}
</script>

<style lang="scss">
  $brightGreen: #b1faee7f;
  $green: #ceeeeb7f;
  $brightYellow: #f7f6997f;
  $yellow: #fbfbcc7f;
  $transparent: transparent;

  .b-brightGreen {
    background-color: $brightGreen;
  }

  .b-green {
    background-color: $green;
  }

  .b-brightYellow {
    background-color: $brightYellow;
  }

  .b-yellow {
    background-color: $yellow;
  }

  .b-white {
    background-color: $transparent;
  }
</style>
